import type { PlanInquiryStatus } from '@src/models/enterprise-inquiry';
import {
    PlanInquiryStatus as PlanInquiryStatusEnum,
    ApplicationBusinessType,
    PaymentMethod,
    PaymentMethod as PaymentMethodEnum,
} from '@uniquegood/realworld-admin-interface';

// 문의 상태 상수 (API 값과 매핑)
export const INQUIRY_STATUSES: { value: PlanInquiryStatus; label: string }[] = [
    { value: PlanInquiryStatusEnum.Inbound, label: '인입' },
    { value: PlanInquiryStatusEnum.InDiscussion, label: '논의 중' },
    { value: PlanInquiryStatusEnum.Excluded, label: '제외' },
    { value: PlanInquiryStatusEnum.Confirmed, label: '완료' },
];

// 문의 상태 상수 (필터용 - '모두 보기' 포함)
export const INQUIRY_STATUSES_FILTER: { value: string; label: string }[] = [
    { value: 'all', label: '모두 보기' },
    ...INQUIRY_STATUSES.map(s => ({ value: s.value, label: s.label })),
];

// 문의 담당자 상수
export const INQUIRY_MANAGERS: { value: string; label: string }[] = [
    { value: 'none', label: '미정' },
    { value: 'Li1uHswtR9W13p-PrMf1qw', label: '허승희' },
    { value: 'gLbDd0sfRreJpXBXierQRg', label: '임대근' },
    { value: 'tAaZH8lNFogVYG480hvOIw', label: '이희근' }
];

// 문의 담당자 상수 (필터용 - '모두 보기' 포함)
export const INQUIRY_MANAGERS_FILTER: { value: string; label: string }[] = [
    { value: 'all', label: '모두 보기' },
    ...INQUIRY_MANAGERS,
];

// 상태별 색상 매핑 (Tag용)
export const getStatusColor = (status: PlanInquiryStatus): 'gray' | 'primary' | 'yellow' | 'green' | 'red' | 'black' | 'transparent' => {
    switch (status) {
        case PlanInquiryStatusEnum.Inbound: return 'primary';
        case PlanInquiryStatusEnum.Excluded: return 'gray';
        case PlanInquiryStatusEnum.InDiscussion: return 'yellow';
        case PlanInquiryStatusEnum.Confirmed: return 'green';
        default: return 'gray';
    }
};

// 상태별 배경색 매핑 (드롭다운용)
export const getStatusBgColor = (status: PlanInquiryStatus): string => {
    switch (status) {
        case PlanInquiryStatusEnum.Inbound: return 'bg-[#E6F4FF]';
        case PlanInquiryStatusEnum.Excluded: return 'bg-[#F0F0F0]';
        case PlanInquiryStatusEnum.InDiscussion: return 'bg-[#FFF7E6]';
        case PlanInquiryStatusEnum.Confirmed: return 'bg-[#E6F7FF]';
        default: return 'bg-[#F0F0F0]';
    }
};

// 상태별 텍스트 색상 매핑 (드롭다운용)
export const getStatusTextColor = (status: PlanInquiryStatus): string => {
    switch (status) {
        case PlanInquiryStatusEnum.Inbound: return 'text-[#3C78F4]';
        case PlanInquiryStatusEnum.Excluded: return 'text-[#595959]';
        case PlanInquiryStatusEnum.InDiscussion: return 'text-[#D46B08]';
        case PlanInquiryStatusEnum.Confirmed: return 'text-[#13C2C2]';
        default: return 'text-[#595959]';
    }
};

// 상태 라벨 조회
export const getStatusLabel = (status: PlanInquiryStatus): string => {
    return INQUIRY_STATUSES.find(s => s.value === status)?.label || '인입';
};

// 담당자 라벨 조회
export const getManagerLabel = (adminId: string | null | undefined): string => {
    const id = adminId || 'none';
    return INQUIRY_MANAGERS.find(m => m.value === id)?.label || '미정';
};

// 비즈니스 타입 매핑
export const BUSINESS_TYPE_LABELS: Record<ApplicationBusinessType, string> = {
    [ApplicationBusinessType.None]: '해당없음',
    [ApplicationBusinessType.General]: '일반 기업',
    [ApplicationBusinessType.Agency]: '이벤트∙광고대행사',
    [ApplicationBusinessType.School]: '초∙중∙고등학교',
    [ApplicationBusinessType.Government]: '공공기관∙지자체∙비영리단체',
    [ApplicationBusinessType.University]: '대학교∙대학원',
    [ApplicationBusinessType.Museum]: '도서관∙과학관∙박물관',
};

// 결제 수단 매핑
export const getPaymentMethodLabel = (method: PaymentMethod): string => {
    switch (method) {
        case PaymentMethodEnum.Card:
            return '카드 결제';
        case PaymentMethodEnum.Transfer:
            return '계좌이체';
        case PaymentMethodEnum.EasyPay:
            return '간편 결제';
        default:
            return '미정';
    }
};

